import { useTranslation } from 'react-i18next';
import { AlloyButton, Modal, useModal } from 'cat-ecommerce-alloy';
import { useDispatch } from 'react-redux';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import { clearError } from '@app/store/exception/actions';
import EmptyCartConfirmationModal from '../../modal/EmptyCartConfirmationModal';
import styles from './EmptyCartButton.module.scss';

const EmptyCartButton = () => {
  const emptyCartConfirmationModalProps = useModal();
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const emptyCart = () => {
    dispatch(clearError(ERROR_DOMAIN.CART, ERROR_PATH.EMPTY_CART_EMPTY_MODAL));
    emptyCartConfirmationModalProps.open();
  };

  return (
    <div className={`mt-md-2 ${styles['float-md-start']} d-print-none`}>
      <AlloyButton
        buttonType="ghost"
        size="dynamic"
        onClick={emptyCart}
        className={`px-md-0 ${styles['empty-cart__btn']}`}
      >
        {t('EMPTY_SHOP_CART2')}
      </AlloyButton>
      <Modal
        close={emptyCartConfirmationModalProps.close}
        isOpen={emptyCartConfirmationModalProps.isOpen}
        title={t('EMPTY_SHOP_CART2')}
      >
        <EmptyCartConfirmationModal
          closeModal={emptyCartConfirmationModalProps.close}
        />
      </Modal>
    </div>
  );
};

export default EmptyCartButton;
